/**
 * Conecta los CTAs propios de Kifoni con el único chat público: Shopify Inbox.
 * Shopify no documenta una API de apertura; se usa progresivamente el activador
 * nativo expuesto por el web component y se mantiene un mensaje de fallback.
 *
 * I18N-FR: este fichero no contiene ni un literal traducible. Los mensajes de
 * estado los resuelve Liquid y llegan en window.kfI18n.inbox (los inyectan
 * sections/kifoni-budget-planner.liquid y sections/kifoni-inline-configurador.liquid).
 */
(function () {
  if (window.KifoniInboxBridge) return;

  const I18N = (window.kfI18n && window.kfI18n.inbox) || {};

  function setStatus(message) {
    document.querySelectorAll('[data-kf-inbox-status]').forEach((node) => {
      node.textContent = message || '';
    });
  }

  function nativeActivator() {
    const host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector([
      'button[part~="activator"]',
      'button.activator',
      'button[aria-expanded]',
      'button[aria-haspopup="dialog"]'
    ].join(', '));
  }

  function tryOpen() {
    const activator = nativeActivator();
    if (!activator) return false;
    if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
    activator.focus({ preventScroll: true });
    return true;
  }

  async function copyPrompt(prompt) {
    if (!prompt || !navigator.clipboard || !navigator.clipboard.writeText) return false;
    try {
      await navigator.clipboard.writeText(prompt);
      return true;
    } catch (error) {
      return false;
    }
  }

  async function open(trigger) {
    const prompt = trigger && trigger.dataset ? trigger.dataset.kfInboxPrompt : '';
    const copied = await copyPrompt(prompt);
    if (tryOpen()) {
      setStatus(copied ? I18N.copied : I18N.opened);
      return;
    }

    setStatus(I18N.loading);
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (tryOpen()) {
        window.clearInterval(timer);
        setStatus(copied ? I18N.copied : I18N.opened);
      } else if (attempts >= 8) {
        window.clearInterval(timer);
        setStatus(I18N.fallback);
      }
    }, 250);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-kf-open-inbox]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });

  window.KifoniInboxBridge = { open };
})();
